import { defineStore } from 'pinia'
import baseService from '@/utils/http/axios'

export interface MaterialArticleItem {
  id: string | number
  storeTypeCode: string
  storeTypeStr: string
  categoryCode: string
  categoryStr: string
  title: string
  keyword: string
  content: string
  sortOrder: number
  clickCount: number
  clickUserCount: number
  createTime: string
}

export const useMaterialArticle = defineStore('materialArticle', {
  state: () => ({}),
  actions: {
    // 分页查询文章资料
    async getArticlePage(params: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/materialArticle/page',
          method: 'get',
          params
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 文章资料详情
    async getArticleInfo(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/materialArticle/info/${id}`,
          method: 'get'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 新增文章资料
    async createArticle(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/materialArticle/create',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 编辑文章资料
    async updateArticle(data: object) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: '/console/materialArticle/update',
          method: 'post',
          data
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 删除文章资料
    async deleteArticle(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/materialArticle/del/${id}`,
          method: 'post'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 增加点击次数
    async clickArticle(id: string | number) {
      return new Promise((resolve, reject) => {
        return baseService({
          url: `/console/materialArticle/click/${id}`,
          method: 'post'
        })
          .then((res: any) => {
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
})
